<template>
  <div class="goodslist" id="goodslist">
    <!--头部导航-->
    <GlobTopNav title="商品列表"></GlobTopNav>

    <div class="pop1" v-if="lodingshow">
      <van-loading type="spinner" />
    </div>
    <div class="header">
      <!--搜索框-->
      <div class="seachbox" action="/">
        <div class="ellipse">
          <!--地址选择弹框-->
          <img src="./../../assets/img/dv.svg" alt="" />
          <div @click="cityPickershow" class="text">{{ address.xq }}</div>
          <van-icon name="arrow-down" color="rgba(38, 38, 38, 0.3)" />

          <City-Picker ref="CityPicker" @listenSitedata="geSitedatas"></City-Picker>
        </div>

        <van-search
          placeholder="请输入商品关键字"
          v-model="search_keywords"
          show-action
          @search="onSearch(search_keywords)"
          @input="descInput(search_keywords)"
          class="seach-input"
        >
          <div slot="action" class="searchbtn" @click="onSearch(search_keywords)">搜索</div>
        </van-search>
      </div>

      <!--排序-->
      <van-tabbar class="sort">
        <div class="van-tabbar-item" @click="sortPlay(0)">
          <div class="van-tabbar-item__text" :class="this.type == 0 ? 'theme-col' : ''">默认</div>
        </div>
        <div class="van-tabbar-item" @click="sortPlay(2)">
          <div class="van-tabbar-item__text">
            <span :class="this.type == 2 ? 'theme-col' : ''">{{ unit }}</span>
            <div class="infotop" :class="this.type == 2 && this.sort == 0 ? 'theme-col' : ''">
              <i class="iconfont icon-shang"></i>
            </div>
            <div class="infobottom" :class="this.type == 2 && this.sort == 1 ? 'theme-col' : ''">
              <i class="iconfont icon-xia"></i>
            </div>
          </div>
        </div>
        <div class="van-tabbar-item" @click="sortPlay(1)">
          <div class="van-tabbar-item__icon"></div>
          <div class="van-tabbar-item__text" :class="this.type == 1 ? 'theme-col' : ''">时间</div>
        </div>
        <div class="van-tabbar-item filtrate" @click="shuaixuan">
          <div class="van-tabbar-item__icon"></div>
          <div
            style="text-align: center; left: 0.06rem; line-height: 0.15rem"
            class="van-tabbar-item__text"
          >
            <span :class="this.type == 4 ? 'theme-col' : ''">筛选</span>
            <i v-if="this.filtrate == true" class="iconfont icon-shang"></i>
            <i v-if="this.filtrate == false" class="iconfont icon-xia"></i>
          </div>
        </div>
      </van-tabbar>
    </div>

    <!--主体-->
    <div class="conter">
      <!-- 专题图片 -->
      <div class="zttp" v-if="$route.query.stype && datas1.image_url_wap">
        <a :href="datas.image_link_wap"><img :src="datas1.image_url_wap" /></a>
      </div>
      <!--商品列表-->
      <div class="nodata text-cent" v-if="finished && datas.length == 0 && nodata">
        <img src="./../../assets/img/prod-null.png" />
        <span class="text">暂无商品~</span>
      </div>
      <van-list offset="1000" v-model="loading" :finished="finished" @load="onLoad">
        <div class="product-list">
          <div
            v-for="(items, index) in datas"
            :key="index"
            class="product-item"
            v-if="pagesocket[items.id_spro] !== '无货'"
          >
            <router-link :to="{ path: '/goodslist/goods', query: { id: items.id } }">
              <div class="product-img">
                <img v-lazy="items.image" onerror="src='/static/errorimg1.png'" />
                <div class="nostock" v-if="pagesocket[items.id_spro] == '无货'">暂无库存</div>
              </div>
              <div class="product-cont">
                <div class="product-name">
                  <span class="tagbox">
                    <span class="tag xl" v-if="items.source == 4"> 一乡一物 </span>
                    <span class="tag xl" v-if="items.source == 3">卡券</span>
                    <span class="tag zc" v-if="items.source == 2">直充</span>
                    <span plain class="tag jd" v-if="items.source == 1">优选</span>
                    <span class="tag yx" v-if="items.source == 6">严选</span>
                  </span>
                  {{ items.name }}
                </div>

                <p class="product-price">
                  <span v-if="items.price_points">{{ items.price_points }}{{ unit }}</span>
                  <span class="product-price" v-if="items.price_cash">
                    <span v-if="items.price_points">+</span>{{ items.price_cash }}元
                  </span>
                </p>
                <p
                  class="product-market"
                  style="font-size: 0.24rem; text-decoration: line-through; color: #9d9d9d"
                  v-if="$store.state.webCount.market_status == 1"
                >
                  市场价:{{ items.market_price }}元
                </p>
                <p
                  class="product-market"
                  style="font-size: 0.24rem; color: #9d9d9d"
                  v-if="items.stock_status == 1 && stockShow == 1"
                >
                  库存:{{ items.stock_number }}
                </p>
                
              </div>
            </router-link>
          </div>
        </div>
      </van-list>
      <div v-if="!loading && finished && datas != ''" class="nomore">
        <div class="theEnd">已经到底了</div>
      </div>
    </div>
    <div
      v-show="this.filtrate == true"
      :class="this.filtrate == true ? 'show' : ''"
      class="pop"
    ></div>

    <van-popup v-model="filtrate" position="right" round :style="{ width: '86%', height: '100%' }">
      <div class="screen">
        <!-- <van-cell class="title">请输入{{ unit }}值</van-cell> -->
        <h3 class="title">价格区间</h3>

        <div class="point-scope">
          <input
            v-model="point_min"
            class="minnum"
            :class="whichnum == 0 ? 'on' : ''"
            placeholder="最低价"
            type="number"
            @click="showkeyboard(0)"
          />
          <span class="inline">-</span>
          <input
            v-model="point_max"
            class="minnum maxnum"
            :class="whichnum == 1 ? 'on' : ''"
            placeholder="最高价"
            type="number"
            @click="showkeyboard(1)"
          />
        </div>

        <div class="interval">
          <div
            class="interval-value"
            v-for="(item, index) in intervalValue"
            :key="index"
            @click="changeInterval(item)"
          >
            {{ item.start }} - {{ item.end }}
          </div>
        </div>

        <div class="botton-cont">
          <van-button class="choiceBotton reset" size="normal" @click="reset">重置</van-button>
          <van-button class="choiceBotton sure" @click="screenPlay(true)"> 确认 </van-button>
        </div>
      </div>
    </van-popup>

    <van-number-keyboard
      :show="show"
      close-button-text="完成"
      @blur="show = false"
      @input="onInput"
      @delete="onDelete"
      @hide="hide"
      theme="custom"
    />
  </div>
</template>

<script>
import CityPicker from "@/pages/user/mysite/cityPicker";
import Password from "../user/personal/password";
import TopNav from "../../components/topnav";
import Bus from "../../../static/js/bus.js";
import store from "../../vuex/store";
export default {
  components: { CityPicker, Password, TopNav },
  name: "goodslist",
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    },
    stockShow: function() {
      return this.$store.state.mallStockShow;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "Goods") {
      // 这个name是下一级页面的路由name
      to.meta.isback = true; // 设置为true说明你是返回到这个页面，而不是通过跳转从其他页面进入到这个页面
    } else {
      //        console.log(from)
      to.meta.isback = false;
    }
    next();
  },
  activated() {
    var mallid = localStorage.getItem("mallid");
    if (!this.$route.meta.isback) {
      this.filtrate = false;
      this.datas = [];
      this.ajaxfrom = {};
      this.finished = false;
      this.id = this.$route.query.id;
      this.type = 0;
      this.ajaxfrom.stype = this.$route.query.stype;
      this.ajaxfrom.id_example = mallid;
      this.ajaxfrom.terminal = "wap";
      this.ajaxfrom.page = 0;
      this.ajaxfrom.count = 10;
      this.search_keywords = "";
      if (this.$route.query.max != undefined) {
        this.ajaxfrom.point_pre = 0;
        this.ajaxfrom.point_post = this.$route.query.max;
      }
      if (this.id == -1) {
        this.getDatas();
      } else {
        this.ajaxfrom.clas_id = this.id;
        this.ajaxfrom.page = 0;
        this.ajaxfrom.stype = this.$route.query.stype;
        this.getDatas();
      }
    }
    // this.ajaxfrom.page = 0;
    this.$route.meta.isback = false;
  },
  store,
  data() {
    return {
      t: true,
      filtrate: false, //筛选弹出
      activeName: 1,
      datas1: {},
      datas: [], //商品数据
      activeClass: "1",
      page: 0, //页码
      type: 0, //排序分类
      sort: 0, //排序
      point_min: "", //积分区间最小值
      point_max: "", //积分区间最大值
      search_keywords: "", //搜索关键词
      loading: false, //下拉加载状态
      finished: false, //下拉加载是否开启
      nodata: false,
      ajaxfrom: {},
      searchfrom: {},
      id: this.$route.query.id,
      stype: this.$route.query.stype,
      max: this.$route.query.max,
      title1: "",
      n: 0,
      show: false, //数字键盘弹出
      showBtn: true, // 控制按钮盒子显示隐藏
      whichnum: 0, //点击哪一个，是最大值还是最小值
      nums: "", //输入具体的数字
      lodingshow: true,
      timer: null, //定义定时器
      counter: 0, //计时器
      trun: true,
      address: this.$store.state.address, //京东查库存显示地址
      pagesocket: {}, //京东商品库存
      idarr: "",
      intervalValue: []
    };
  },

  methods: {
    changeInterval(item) {
      this.point_min = item.start;
      this.point_max = item.end;
      this.sortPlay(4);
      this.filtrate = false;
    },
    // 获取价格区间
    getPriceRange() {
      var mallid = localStorage.getItem("mallid");
      this.$api.get(
        "/product/filterMenu",
        {
          id_example: mallid
        },
        res => {
          console.log("res :>> ", res);
          this.intervalValue = res.data.data.list;
        }
      );
    },
    shuaixuan: function() {
      this.filtrate = !this.filtrate;
      // this.point_min=''
      // this.point_max=''
      this.whichnum = 0;
    },
    showkeyboard: function(a) {
      this.nums = "";
      this.whichnum = a;
      this.show = true;
    },
    onInput(value) {
      this.nums += value;
      if (this.whichnum == 0) {
        this.point_min = this.nums;
      } else {
        this.point_max = this.nums;
      }
    },
    hide() {
      this.nums = "";
    },
    onDelete() {
      var n = this.nums;
      var s = n.substring(0, n.length - 1);
      if (this.whichnum == 0) {
        this.nums = s;
        this.point_min = this.nums;
      } else {
        this.nums = s;
        this.point_max = this.nums;
      }
    },
    descInput(key) {
      this.search_keywords = key;
    },
    goBack: function() {
      history.back(-1);
    },

    reset: function() {
      this.point_min = "";
      this.point_max = "";
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    popupPlay: function() {
      this.popupshow = true;
      if (this.classesdatas == "") {
        this.getClassesdatas();
      }
    },
    onLoad: function() {
      setTimeout(() => {
        console.log(this.ajaxfrom.page, ">>we");

        this.getDatas();
      }, 800);
    },
    // 获取数据
    getDatas: function() {
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      if (this.$route.query.max != undefined) {
        //我能兑换
        this.ajaxfrom.point_pre = 0;
        this.ajaxfrom.point_post = this.$route.query.max;
      }
      //        this.timer =setTimeout(() => {
      this.ajaxfrom.page++;
      this.ajaxfrom.stype = this.$route.query.stype;
      if (this.trun) {
        this.trun = false;
        this.$api.get(
          "product/goodslist",
          //            {
          //            id_example:mallid,//商城实例ID
          //            terminal:'wap',//
          //            clas_id:_this.id,//分类id
          //            add_time:'',//1 （降序） 无则不传或空值
          //            sale:'',//销量 0 否 1 是
          //            price:'',//价格 0 升序 1 降序
          //            point_pre:'',//积分区间 前置
          //            point_post:'',//积分区间 后置（不能为零0）
          //            page:this.page,//页码
          //            count:10,//显示条数
          //            name:'',//搜索名称
          //          }
          this.ajaxfrom,
          res => {
            console.log(res.data);
            this.datas1 = res.data.data;
            if (_this.$route.query.max != undefined) {
              //我能兑换
              _this.title1 = "我能兑换";
            } else if (res.data.data.type_name != undefined) {
              this.title1 = res.data.data.type_name;
            } else {
              _this.title1 = "全部商品";
            }
            console.log(this.ajaxfrom.page);
            if (res.data.data.list.length == 0) {
              if (_this.datas.length == 0) {
                _this.nodata = true;
              }
              _this.finished = true;
              _this.loading = false;
              _this.trun = true;
            } else {
              var arr = "";
              for (let i = 0; i < res.data.data.list.length; i++) {
                if (
                  res.data.data.list[i].source != 2 &&
                  res.data.data.list[i].source != 3 &&
                  res.data.data.list[i].source != 5
                ) {
                  arr += res.data.data.list[i].id_spro + ",";
                  _this.idarr += res.data.data.list[i].id_spro + ",";
                }

                _this.datas.push(res.data.data.list[i]);
              }
              console.log(_this.datas);
              if (arr != "") {
                this.checksocket(arr);
              }
              _this.nodata = false;
              _this.loading = false;
              _this.trun = true;
            }
            _this.lodingshow = false;
          },
          err => {
            this.$router.push({ name: "Overtime" });
          }
        );
      }
      //        },500)
    },
    checksocket: function(id) {
      //查询京东库存
      id = id.substr(0, id.length - 1); //地址
      var mallid = localStorage.getItem("mallid");
      this.$api.get(
        "/product/jd/stock",
        {
          id_example: mallid,
          id_product: id,
          id_province: this.address.province_id,
          id_city: this.address.city_id,
          id_county: this.address.country_id
        },
        res => {
          if (res.data.code == "100") {
            res.data.data.forEach(item => {
              // this.pagesocket[item.code]=item.result
              this.$set(this.pagesocket, item.code, item.desc);
            });
          }
        }
      );
    },
    // 搜索关键词
    onSearch: function(key) {
      this.type = 0;
      this.lodingshow = true;
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      this.page = 0;
      this.datas = [];
      this.page = 0;
      this.ajaxfrom = {};
      this.type = 0;
      if (key != undefined && key != "") {
        //            if(_this.id==-1){
        //              _this.ajaxfrom.id_example=mallid;
        //              _this.ajaxfrom.terminal='wap';
        //              _this.ajaxfrom.name=key;
        //              _this.ajaxfrom.page = _this.page;
        //            }else{
        //              _this.ajaxfrom.id_example=mallid;
        //              _this.ajaxfrom.terminal='wap';
        //              _this.ajaxfrom.clas_id=_this.id;
        //              _this.ajaxfrom.name=key;
        //              _this.ajaxfrom.page = _this.page;
        //            }
        //            _this.getDatas()
        this.sortPlay(5, key);
        this.type = 0;
      } else {
        //            _this.type=0
        //          if(_this.id==-1){
        //            _this.ajaxfrom.id_example=mallid;
        //            _this.searchfrom.terminal='wap';
        //            _this.ajaxfrom.page = _this.page;
        //          }else{
        //            _this.ajaxfrom.id_example=mallid;
        //            _this.ajaxfrom.terminal='wap';
        //            _this.ajaxfrom.clas_id=_this.id;
        //            _this.ajaxfrom.page = _this.page;
        //          }
        //          _this.getDatas()
        this.sortPlay(5, key);
        this.type = 0;
      }
    },
    // 排序
    sortPlay: function(e, key) {
      this.type = e;
      this.datas = [];
      this.page = 0;
      this.ajaxfrom = {};
      //        this.search_keywords=''
      this.sort == 0 ? (this.sort = 1) : (this.sort = 0);
      var mallid = localStorage.getItem("mallid");
      if (this.point_min != "" && this.point_max != "") {
        //删选
        this.ajaxfrom.point_pre = this.point_min;
        this.ajaxfrom.point_post = this.point_max;
      }
      this.ajaxfrom.id_example = mallid;
      this.ajaxfrom.terminal = "wap";
      this.ajaxfrom.page = this.page;
      this.ajaxfrom.count = 10;
      if (this.id == -1) {
        //全部商品
        if (this.search_keywords == "") {
          if (e == -1) {
            this.type = 0;
          } else if (e == 1) {
            //时间
            this.ajaxfrom.add_time = 1;
          } else if (e == 2) {
            //积分
            if (this.sort == 0) {
              this.ajaxfrom.price = 0;
            } else {
              this.ajaxfrom.price = 1;
            }
          } else if (e == 3) {
            //销量
            this.ajaxfrom.sale = 1;
          } else if (e == 4) {
            //筛选积分区间
            if (this.id != -1) {
              this.ajaxfrom.clas_id = this.id;
            }
            this.ajaxfrom.point_pre = this.point_min;
            this.ajaxfrom.point_post = this.point_max;
          } else if (e == 5) {
            //搜索后再筛选
            this.ajaxfrom.name = key;
          }
        } else {
          if (e == 0) {
            this.ajaxfrom.name = this.search_keywords;
            this.type = 0;
          } else if (e == -1) {
            this.type = 0;
            this.ajaxfrom.name = this.search_keywords;
          } else if (e == 1) {
            //时间
            this.ajaxfrom.add_time = 1;
            this.ajaxfrom.name = this.search_keywords;
          } else if (e == 2) {
            //积分
            if (this.sort == 0) {
              this.ajaxfrom.price = 0;
            } else {
              this.ajaxfrom.price = 1;
            }
            this.ajaxfrom.name = this.search_keywords;
          } else if (e == 3) {
            //销量
            this.ajaxfrom.sale = 1;
            this.ajaxfrom.name = this.search_keywords;
          } else if (e == 4) {
            //筛选积分区间
            if (this.id != -1) {
              this.ajaxfrom.clas_id = this.id;
            }
            this.ajaxfrom.name = this.search_keywords;
            this.ajaxfrom.point_pre = this.point_min;
            this.ajaxfrom.point_post = this.point_max;
          } else if (e == 5) {
            //搜索后再筛选
            this.ajaxfrom.name = key;
          }
        }
      } else {
        //其他分类
        if (this.search_keywords == "") {
          if (e == 0) {
            this.ajaxfrom.clas_id = this.id;
          } else if (e == 1) {
            //时间
            this.ajaxfrom.clas_id = this.id;
            this.ajaxfrom.add_time = 1;
          } else if (e == 2) {
            //积分
            if (this.sort == 0) {
              this.ajaxfrom.price = 0;
            } else {
              this.ajaxfrom.price = 1;
            }
            this.ajaxfrom.clas_id = this.id;
          } else if (e == 3) {
            //销量
            this.ajaxfrom.clas_id = this.id;
            this.ajaxfrom.sale = 1;
          } else if (e == 4) {
            //筛选积分区间
            if (this.id != -1) {
              this.ajaxfrom.clas_id = this.id;
            }
            this.ajaxfrom.point_pre = this.point_min;
            this.ajaxfrom.point_post = this.point_max;
          } else if (e == 5) {
            //搜索完再筛选
            this.ajaxfrom.clas_id = this.id;
            this.ajaxfrom.name = key;
          }
        } else {
          if (e == 0) {
            this.ajaxfrom.clas_id = this.id;
            this.ajaxfrom.name = this.search_keywords;
          } else if (e == 1) {
            //时间
            this.ajaxfrom.clas_id = this.id;
            this.ajaxfrom.name = this.search_keywords;
            this.ajaxfrom.add_time = 1;
          } else if (e == 2) {
            //积分
            if (this.sort == 0) {
              this.ajaxfrom.price = 0;
            } else {
              this.ajaxfrom.price = 1;
            }
            this.ajaxfrom.name = this.search_keywords;
            this.ajaxfrom.clas_id = this.id;
          } else if (e == 3) {
            //销量
            this.ajaxfrom.clas_id = this.id;
            this.ajaxfrom.name = this.search_keywords;
            this.ajaxfrom.sale = 1;
          } else if (e == 4) {
            //筛选积分区间
            if (this.id != -1) {
              this.ajaxfrom.clas_id = this.id;
            }
            this.ajaxfrom.name = this.search_keywords;
            this.ajaxfrom.point_pre = this.point_min;
            this.ajaxfrom.point_post = this.point_max;
          } else if (e == 5) {
            //搜索完再筛选
            this.ajaxfrom.clas_id = this.id;
            this.ajaxfrom.name = key;
          }
        }
      }

      if (this.finished) {
        this.finished = false;
      } else {
        this.loading = true;
        this.getDatas();
      }
    },
    //筛选
    screenPlay: function() {
      var reg = /^[1-9]\d*$/;
      if (this.point_min == "" || this.point_max == "") {
        this.$dialog
          .alert({
            title: "提示",
            message: "输入值不能为空！"
          })
          .then(() => {
            // on close
          });
      } else if (Number(this.point_max) <= Number(this.point_min)) {
        //        }else if(this.point_max <= this.point_min){
        this.$toast("输入区间输入有误！");
      } else {
        if (reg.test(this.point_min && this.point_max)) {
          this.filtrate = !this.filtrate;
          this.sortPlay(4);
          this.type = 0;
        } else {
          this.point_min = "";
          this.point_max = "";
          this.$toast("输入区间必须为正整数,请重新输入！");
        }
      }
    },
    cityPickershow: function() {
      //地址列表
      this.$refs.CityPicker.setSiteShow(true);
    },
    geSitedatas: function(datas) {
      if (datas[3] != undefined && datas[3].name == "请选择") {
        this.$toast("请填写完成地址");
        return false;
      }
      var area = "";
      if (datas[0] != undefined) {
        area += datas[0].name;
      }
      if (datas[1] != undefined) {
        area += "-" + datas[1].name;
      }
      if (datas[2] != undefined) {
        area += "-" + datas[2].name;
      }
      if (datas[3] != undefined) {
        area += "-" + datas[3].name;
      }
      var json = {
        area: area,
        province_id: datas[0].id,
        city_id: datas[1].id,
        country_id: datas[2].id,
        town_id: datas[3] ? datas[3].id : 0
      };
      this.$store.commit("setAddress", json);
      this.ajaxfrom.page = 0;
      this.datas = [];
      this.getDatas();
      // this.$refs.CityPicker.setSiteShow(false);
      // this.checksocket(this.idarr)
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.$route.query.id == -1) {
      this.sortPlay(-1);
    } else {
      this.sortPlay(0);
    }
  },
  created() {
    //      var vm = this
    //      Bus.$on('notice', function (data) {
    //        vm.title1 = data
    //      })
    this.ajaxfrom.page = 0;
    this.getPriceRange();
    console.log(this.$route);
    this.ajaxfrom.stype = this.$route.query.stype;
    console.log(this.ajaxfrom.stype);
  },
  destroyed: function() {
    this.filtrate = false;
  }
};
</script>
<style lang="less">
.goodslist {
  background: #f5f5f5;
  .zttp {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .pop1 {
    background-color: #fff !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    .van-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -0.15rem 0 0 -0.15rem;
    }
  }
  .pop.show {
    background: rgba(0, 0, 0, 0.5);
  }
  .pop {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 1.34rem;
  }

  .van-cell.van-cell--borderless.van-field {
    background: #f4f4f4;
    border-radius: 0.2rem;
  }
  .van-nav-bar__title {
    max-width: 67%;
    text-align: left;
  }

  .header {
    position: fixed;
    top: 0.96rem;
    width: 100%;
    z-index: 9;
    background: #fff;
    padding-top: 0.2rem;
    border-top: 0.01rem solid #f2f2f2;

    .seachbox {
      width: 100%;
      box-sizing: border-box;
      padding: 0 0.2rem;
      display: flex;
      justify-content: space-between;

      .ellipse {
        min-width: 1.8rem;
        display: flex;
        align-items: center;

        .text {
          display: inline-block;
          width: 1.3rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 0.24rem;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #262626;
          line-height: 0.42rem;
        }
      }

      .seach-input {
        flex: 1;
        width: 5rem;
        height: 0.7rem;
        background: #f2f2f2;
        border-radius: 0.35rem;
        margin-left: 0.2rem;

        .van-search__content {
          background-color: #f2f2f2;
          padding: 0;
        }

        .van-search__action {
          padding: 0;

          .searchbtn {
            width: 1.22rem;
            height: 0.7rem;
            background: #e23130;
            border-radius: 0rem 0.35rem 0.35rem 0rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.26rem;
            font-weight: 400;
            color: #ffffff;
            line-height: 0.36rem;
          }
        }
      }
    }
  }

  .sort {
    border-bottom: 0.01rem solid #f2f2f2;
    position: relative;
    height: 0.9rem;

    &::after {
      border: none;
    }

    .theme-col {
      color: #e53a34 !important;
    }

    .van-tabbar-item__icon {
      display: none;
    }
    .van-tabbar-item {
      padding: 0.15rem 0;

      .van-tabbar-item__text {
        font-size: 0.28rem;
        font-weight: 400;
        color: #262626;
        line-height: 0.48rem;
        position: relative;

        .infotop,
        .infobottom {
          background-color: inherit;
          color: #000;
          position: absolute;
          right: -0.3rem;
          font-size: 0.28rem;
        }
        .infotop .iconfont,
        .infobottom .iconfont {
          font-size: 0.2rem;
        }
        .infotop {
          top: -0.1rem;
        }
        .infobottom {
          bottom: -0.1rem;
        }
      }
    }
    .brandbox {
      position: relative;

      .van-collapse-item__content {
        position: fixed;
        width: 100vw;
        left: 0;
        box-sizing: border-box;
        top: 1.74rem;
        padding: 0;
        .van-cell,
        .van-row {
          padding: 0rem;
        }
        .van-row {
          .van-col {
            text-align: center;
            margin: 0.08rem 0;
            div {
              font-size: 1.6rem;
              padding: 0.05rem 0;
              border: 0.01rem solid #bdbdbd;
              border-radius: 0.03rem;
            }
          }
        }
      }
    }
  }

  .conter {
    padding-top: 1.8rem;
    min-height: 100vh;

    .product-list {
      padding: 0.6rem 0.2rem 0 0.2rem;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .product-item {
        width: 3.44rem;
        height: auto;
        background: #ffffff;
        box-shadow: 0rem 0rem 0.4rem 0rem rgba(193, 193, 193, 0.2);
        border-radius: 0.15rem;
        overflow: hidden;
        margin-top: 0.2rem;

        .product-img {
          width: 3.44rem;
          height: 3.44rem;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .nostock {
            position: absolute;
            width: 1.8rem;
            height: 1.8rem;
            text-align: center;
            line-height: 1.8rem;
            color: white;
            border-radius: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: rgba(30, 30, 30, 0.6);
          }
        }

        .product-cont {
          box-sizing: border-box;
          padding: 0 0.2rem;
          margin-top: 0.16rem;
          padding-bottom: 0.2rem;

          .product-name {
            height: 0.72rem;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 0.26rem;
            font-weight: 400;
            color: #262626;
            line-height: 0.36rem;
            position: relative;
          }

          .product-price {
            font-size: 0.28rem;
            font-weight: 400;
            color: #fe5c42;
            line-height: 0.4rem;
          }

          .product-market {
            font-size: 0.24rem;
            font-weight: 400;
            color: #929292;
            line-height: 0.42rem;
          }
        }
      }
    }
  }
  .searchbtn {
    padding: 0 0.1rem;
  }

  .screen {
    width: 100%;
    box-sizing: border-box;
    padding: 1rem 0.3rem;

    .title {
      font-size: 0.36rem;
      font-weight: 500;
      color: #262626;
      line-height: 0.5rem;
    }

    .point-scope {
      margin-top: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.1rem;
      .minnum {
        width: 2.42rem;
        height: 0.6rem;
        background: #f2f2f2;
        border-radius: 0.3rem;
        background-color: rgba(242, 242, 242, 1);
        border: none;
        text-align: center;

        &::placeholder {
          font-size: 0.24rem;
          font-weight: 400;
          color: #929292;
          line-height: 0.42rem;
        }
      }
    }

    .interval {
      display: flex;
      flex-wrap: wrap;
      .interval-value {
        min-width: 1.44rem;
        height: 0.6rem;
        background: #f2f2f2;
        border-radius: 0.3rem;
        margin-top: 0.22rem;
        padding: 0 0.2rem;
        margin-left: 0.16rem;
        line-height: 0.6rem;
        text-align: center;
        font-size: 0.26rem;
        font-weight: 400;
        color: #262626;

        &:first-child {
          margin-left: 0;
        }

        &:nth-child(3n + 1) {
          margin-left: 0;
        }
      }
    }

    .botton-cont {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 1.16rem;

      .choiceBotton {
        width: 2.8rem;
        height: 0.8rem;
        background: #fdf5f5;
        border-radius: 0.5rem;
        border: 0.02rem solid #e23331;
        font-size: 0.3rem;
        font-weight: 400;
        color: #e23331;
        line-height: 0.8rem;
      }

      .sure {
        background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/index.vue